import React, { PropTypes, PureComponent } from 'react';
import { getSeason } from '../../../../lib/seasons';
import { Button } from '../../../shared';
import ClockIn from './ClockIn';
import Message from './message';
import Camera from './camera';
import styles from './styles.scss';

export class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.undoClockEntry = this.undoClockEntry.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);

    this.state = {
      clockedIn: props.currentUser.clockedIn,
      season: getSeason(Date.now()),
      confirm: false,
    };
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeypress);
    // remove the "your password is X" notification, we no longer need it
    this.props.removeSystemMessageByType('systemTip');
  }

  componentDidMount() {
    this.props.setAndStartTimer(10000);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeypress);
  }

  getControls() {
    const { clockedIn } = this.state;
    const { currentUser } = this.props;
    if (currentUser.userLevels && !currentUser.userLevels.includes('employee')) {
      return (
        <div className={styles.NotEmployee}>
          <p>
            Staff marked as Employees inside Tanda can clock in and out.
            You can access the time clock settings using the buttons below.
          </p>
        </div>
      );
    }

    if (this.adminFirstClockIn()) {
      return (
        <div className={styles.Controls}>
          {this.clockInButton(clockedIn)}
        </div>
      );
    }

    return (
      <div className={styles.Controls}>
        {this.clockInButton(clockedIn)}
        <Button
          className={`${styles.Controls__button} red ${clockedIn ? styles['Pulse--red'] : ''}`}
          onClick={event => this.handleButtonPress(event, 'out')}
          disable={this.state.confirm}
        >
          <p>Clock Out</p>
        </Button>
      </div>
    );
  }


  adminFirstClockIn() {
    return this.props.config && this.props.config.adminFirstClockIn;
  }

  handleButtonPress(e, type) {
    e.preventDefault();

    if (this.state.confirm) {
      return;
    }

    const { season } = this.state;

    let timer = 8000; // 8s
    if (season && season.confirmTimer) {
      timer = season.confirmTimer;
    }

    this.props.setAndStartTimer(timer);
    this.setState({ confirm: type, time: Date.now() });
  }

  handleKeypress(e) {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        this.setState({ confirm: this.state.clockedIn ? 'out' : 'in', time: Date.now() });
        break;
      case 'ArrowDown':
        e.preventDefault();
        this.setState({ clockedIn: true });
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.setState({ clockedIn: false });
        break;
      case 'Escape':
        e.preventDefault();
        this.props.clearUser();
        break;
      default:
        break;
    }
  }

  clockInButton(clockedIn) {
    return (
      <Button
        className={`${styles.Controls__button} green
                      ${clockedIn ? '' : styles['Pulse--green']}`}
        onClick={event => this.handleButtonPress(event, 'in')}
        disable={this.state.confirm}
      >
        <p>Clock In</p>
      </Button>
    );
  }

  undoClockEntry() {
    this.setState({ confirm: null });
  }

  render() {
    return (
      <div className={styles.Home}>
        {
          this.state.confirm ?
            <ClockIn
              type={this.state.confirm}
              time={this.state.time}
              undoClockEntry={() => this.undoClockEntry()}
              {...this.props}
            /> : null
        }

        <Camera {...this.props} />

        <div className={styles.HomeContent}>

          <Message {...this.props} />

          {this.getControls()}
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  config: PropTypes.object,
  currentUser: PropTypes.object,
  clockedIn: PropTypes.array,
  clearUser: PropTypes.func,
  toggleFlash: PropTypes.func,
  setAndStartTimer: PropTypes.func,
  clearFirstTimeClockingIn: PropTypes.func,
  clearTimer: PropTypes.func,
  removeSystemMessageByType: PropTypes.func,
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/main.jsx